export default __webpack_public_path__ + "static/media/Home-foto-header-incoming-Tower-viajes-desk@2x.730dad26.jpg";